'use client'

import { useEffect } from 'react'
import { usePathname } from 'next/navigation'

// Augment globalThis with __dcid
declare global {
  var __dcid: Array<{ cid: string; tag: string }> | undefined
}

const DIGICERT_CID = 'DigiCertClickID_F--6ZX8K'
const DIGICERT_TAG = 'F--6ZX8K'

// TO-DO: DigiCert Config should be in env file
export default function DigiCertSeal({
  allowedDomains,
}: Readonly<{
  allowedDomains: string[]
}>) {
  const pathname = usePathname()

  useEffect(() => {
    if (
      typeof globalThis !== 'undefined' &&
      allowedDomains.includes(globalThis.location.hostname)
    ) {
      globalThis.__dcid = globalThis.__dcid || []
      globalThis.__dcid.push({
        cid: DIGICERT_CID,
        tag: DIGICERT_TAG,
      })

      const existing = document.getElementById('digicert-seal-script')
      if (existing) existing.remove()

      const script = document.createElement('script')
      script.src = 'https://seal.digicert.com/seals/cascade/seal.min.js'
      script.async = true
      script.id = 'digicert-seal-script'
      document.body.appendChild(script)
    }
  }, [pathname, allowedDomains])

  return null
}
